import script from "./OpeningOddView.vue?vue&type=script&setup=true&lang=js"
export * from "./OpeningOddView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__